import type { ComposerApi } from "../useRequestComposer";
import { stepLabel } from "../labels";
import { Glyph } from "./Icons";

/**
 * Avanzamento della pagina, nel linguaggio editoriale del sito («01 —— 2
 * CONFEZIONI»): numero grande, filetto, totale e passo; sotto, i trattini con i
 * nomi. Il totale si adatta all'argomento: «Altro» e «Aiuto con un ordine» sono
 * richieste di 2 passi. I passi completati sono pulsanti per tornarci.
 */
export function StepIndicator({ api }: { api: ComposerApi }) {
  const { steps, stepNumber, state, t } = api;
  const total = steps.length;
  const pad = (n: number) => String(n).padStart(2, "0");
  return (
    <div className="rq-steps">
      <p className="rq-steps__count" aria-hidden="true">
        <span className="rq-steps__num">{pad(stepNumber)}</span>
        <span className="rq-steps__rule" />
        <span className="rq-steps__total">/ {pad(total)} · {stepLabel(t, state.step)}</span>
      </p>
      <ol className="rq-steps__list" aria-label={t("contact.guide.a11y.progress")}>
        {steps.map((s, i) => {
          const status = i + 1 < stepNumber ? "done" : i + 1 === stepNumber ? "current" : "todo";
          return (
            <li key={s} className="rq-steps__item" data-state={status} aria-current={status === "current" ? "step" : undefined}>
              <span className="rq-steps__bar" aria-hidden="true"><span /></span>
              {status === "done" ? (
                <button type="button" className="rq-steps__label" onClick={() => api.goTo(s)}>
                  <Glyph name="check" size={12} />
                  <span className="rq-sr">{t("contact.guide.a11y.done")} </span>
                  {stepLabel(t, s)}
                </button>
              ) : (
                <span className="rq-steps__label">
                  {status === "current" && <span className="rq-sr">{t("contact.guide.a11y.current")} </span>}
                  {stepLabel(t, s)}
                </span>
              )}
            </li>
          );
        })}
      </ol>
    </div>
  );
}

/** Nel pannello: i trattini delle slide della home sotto il sottotitolo «Passo 2 di 3 · Dettagli». */
export function StepDashes({ api }: { api: ComposerApi }) {
  return (
    <span className="rq-dashes" aria-hidden="true">
      {api.steps.map((s, i) => (
        <span key={s} data-on={i + 1 <= api.stepNumber ? "" : undefined} />
      ))}
    </span>
  );
}
